module.exports = __webpack_public_path__ + "img/63.dc5a35a6.jpg";